import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Footer from "./Footer";

//api
import BaseUrl from "../../store/Api";
import { useRecoilValue } from "recoil";
import { authenticated } from "../../store";
import {
  BiUserCircle,
  BiLogOutCircle,
  BiDesktop,
  BiLogIn,
  BiEdit,
} from "react-icons/bi";

function Navbar({ children, logo }) {
  const auth = useRecoilValue(authenticated);

  const [logoApp, setLogoApp] = useState(logo);

  const [navOpen, setNavOpen] = useState(false);
  const [parentActive, setParentActive] = useState(false);

  //get menu profil
  const [menuProfil, setMenuProfil] = useState([]);

  const toggleNav = () => setNavOpen(!navOpen);

  const classNav = !navOpen ? "hidden" : "";

  const Logo = () => {
    if (logoApp === "black") {
      return (
        <img
          className="object-contain md:object-scale-down  h-16 md:h-20"
          src="/assets/images/logo-kehati.png"
          alt="Kehati kaltim"
        />
      );
    }
    return (
      <img
        className="object-contain md:object-scale-down  h-16 md:h-20"
        src="/assets/images/logo-kehati-putih.png"
        alt="Kehati kaltim"
      />
    );
  };

  //logo scroll function
  

  useEffect(() => {
    const changeLogo = () => {
      if (logo !== "black") {
        if (window.scrollY >= 60) {
          setLogoApp("black");
        } else {
          setLogoApp("white");
        }
      }
      if (logo === "black") {
        setLogoApp("black");
      }
    };
    changeLogo();
    // adding the event when scroll change Logo
    window.addEventListener("scroll", changeLogo);
  },[logo]);

  //end get menu user

  useEffect(() => {
    const getMenuProfil = async () => {
      try {
        const dataRequest = {
          tmp_token: "tysoftgroup",
        };
        let response = await BaseUrl.post("menu-profil", dataRequest);
        setMenuProfil(response.data);
      } catch (e) {
        console.log(e.message);
      }
    };
    getMenuProfil();

    
  }, []);

  // useEffect(() => {
  //   setLogoApp(logo);
  // }, [logo]);

  window.document.addEventListener("scroll", function () {
    let scrollpos = window.scrollY;
    let header = document.getElementById("header");
    let navcontent = document.getElementById("nav-content");
    let navaction = document.getElementById("navAction");
    let toToggle = document.querySelectorAll(".toggleColour");

    if (scrollpos > 10) {
      if (header) {
        header.classList.add("bg-white");
      }
      if (navaction) {
        navaction.classList.add("bg-green-700");
        navaction.classList.remove("text-gray-800");
        navaction.classList.add("text-white");
      }

      //Use to switch toggleColour colours
      for (let indx = 0; indx < toToggle.length; indx++) {
        toToggle[indx].classList.add("text-gray-800");
        toToggle[indx].classList.remove("text-white");
      }
      if (header) {
        header.classList.add("shadow");
      }
      if (navaction) {
        navcontent.classList.remove("bg-gray-100");
        navcontent.classList.add("bg-white");
      }
    } else {
      if (header) {
        header.classList.remove("bg-white");
      }
      if (navaction) {
        navaction.classList.remove("bg-green-700");
        navaction.classList.add("bg-white");
        navaction.classList.remove("text-white");
        navaction.classList.add("text-gray-800");
      }
      //Use to switch toggleColour colours
      for (var i = 0; i < toToggle.length; i++) {
        toToggle[i].classList.add("text-white");
        toToggle[i].classList.remove("text-gray-800");
      }
      if (header) {
        header.classList.remove("shadow");
      }
      if (navaction) {
        navcontent.classList.remove("bg-white");
        navcontent.classList.add("bg-gray-100");
      }
    }
  });

  return (
    <div>
      <nav
        id="header"
        className="fixed w-full z-30 top-0 text-white  transition  ease-in-out duration-300">
        <div className="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2 px-4 md:px-8">
          <div className="pl-4 flex items-center">
            <NavLink
              onClick={() => {
                setNavOpen(false);
                setParentActive(false);
              }}
              to="/"
              className="toggleColour text-white no-underline hover:no-underline font-bold text-2xl lg:text-4xl">
              <Logo />
            </NavLink>
          </div>
          <div className="block lg:hidden pr-4">
            <button
              onClick={toggleNav}
              id="nav-toggle"
              className="flex items-center p-1 text-pink-800 hover:text-gray-900 focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out">
              {!navOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>

          <div
            className={`${classNav} w-full flex-grow lg:flex lg:items-center lg:w-auto  mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20 transition duration-500 ease-in-out duration-300`}
            id="nav-content">
            <ul className="list-reset lg:flex justify-end flex-1 items-center  duration-200 mb-4 md:mb-0">
              <li className="mr-3">
                <NavLink
                  exact
                  className="inline-block py-2 px-4 text-teal-700 text-lg font-bold no-underline hover:text-yellow-400"
                  activeClassName="md:text-yellow-300"
                  to="/"
                  onClick={() => {
                    setNavOpen(false);
                    setParentActive(false);
                  }}>
                  Home
                </NavLink>
              </li>
              <li className="mr-3">
                <div className="dropdown">
                  <button
                    className={`py-2 px-4 text-teal-700 text-lg font-bold no-underline hover:text-yellow-400 focus:text-yellow-400 inline-flex items-center focus:outline-none ${
                      parentActive ? `md:text-yellow-300` : ``
                    }`}>
                    <span className="mr-1">Profil</span>
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </button>
                  <ul className="dropdown-menu absolute hidden text-gray-700 pt-1 z-40">
                    {menuProfil.map((mp, index) => {
                      return (
                        <li key={index}>
                          <NavLink
                            onClick={() => {
                              setNavOpen(false);
                              setParentActive(true);
                            }}
                            to={`/profil/${mp.slug}`}
                            className="w-40 bg-white  hover:bg-gray-400 hover:text-yellow-400 font-semibold py-2 px-4 block whitespace-no-wrap"
                            activeClassName="md:text-yellow-300">
                            {mp.judul_profil}
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>

              <li className="mr-3">
                <div className="dropdown">
                  <button
                    className={`py-2 px-4 text-teal-700 text-lg font-bold no-underline hover:text-yellow-400 focus:text-yellow-400 inline-flex items-center focus:outline-none ${
                      parentActive ? `md:text-yellow-300` : ``
                    }`}>
                    <span className="mr-1">Database Kehati</span>
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </button>
                  <ul className="dropdown-menu absolute hidden text-gray-700 pt-1 z-40">
                    <li>
                      <NavLink
                        onClick={() => {
                          setNavOpen(false);
                          setParentActive(true);
                        }}
                        to={`/database/fauna`}
                        className="w-40 bg-white  hover:bg-gray-400 hover:text-yellow-400 font-semibold py-2 px-4 block whitespace-no-wrap"
                        activeClassName="md:text-yellow-300">
                        Fauna
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={() => {
                          setNavOpen(false);
                          setParentActive(true);
                        }}
                        to={`/database/flora`}
                        className="w-40 bg-white  hover:bg-gray-400 hover:text-yellow-400 font-semibold py-2 px-4 block whitespace-no-wrap"
                        activeClassName="md:text-yellow-300">
                        Flora
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={() => {
                          setNavOpen(false);
                          setParentActive(true);
                        }}
                        to={`/database/ekosistem`}
                        className="w-40 bg-white  hover:bg-gray-400 hover:text-yellow-400 font-semibold py-2 px-4 block whitespace-no-wrap"
                        activeClassName="md:text-yellow-300">
                        Ekosistem
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>

              <li className="mr-3">
                <NavLink
                  exact
                  className="mr-3 inline-block py-2 px-4 text-teal-700 text-lg font-bold no-underline hover:text-yellow-400"
                  activeClassName="md:text-yellow-300"
                  to="/berita"
                  onClick={() => {
                    setNavOpen(false);
                    setParentActive(false);
                  }}>
                  Berita
                </NavLink>
              </li>

              <li className="mr-3">
                <NavLink
                  exact
                  className="mr-3 sm:mb-4 md:mb-0 inline-block py-2 px-4 text-teal-700 text-lg font-bold no-underline hover:text-yellow-400"
                  activeClassName="md:text-yellow-300"
                  to="/katalog"
                  onClick={() => {
                    setNavOpen(false);
                    setParentActive(false);
                  }}>
                  Katalog
                </NavLink>
              </li>
              <li className="mr-3">
                <NavLink
                  exact
                  className="mr-3 sm:mb-4 md:mb-0 inline-block py-2 px-4 text-teal-700 text-lg font-bold no-underline hover:text-yellow-400"
                  activeClassName="md:text-yellow-300"
                  to="/repo"
                  onClick={() => {
                    setNavOpen(false);
                    setParentActive(false);
                  }}>
                  Repositori
                </NavLink>
              </li>

              {auth.check && (
                <li className="mr-3">
                  <div className="dropdown">
                    <button
                      className={`py-2 px-4 bg-gray-200 text-teal-700 rounded-md text-lg font-bold no-underline hover:text-yellow-400 focus:text-yellow-400 inline-flex items-center focus:outline-none `}>
                      <span className="mr-1 flex items-center">
                        <BiUserCircle className="mr-1" /> {auth.user.name}
                      </span>
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </button>
                    <ul className="dropdown-menu absolute hidden text-gray-700 pt-1 z-40">
                      <li>
                        <NavLink
                          onClick={() => {
                            setNavOpen(false);
                            setParentActive(true);
                          }}
                          to="/akun"
                          className="flex items-center w-40 bg-white  hover:bg-gray-400 hover:text-yellow-400 font-semibold py-2 px-4 block whitespace-no-wrap"
                          activeClassName="md:text-yellow-300">
                          <BiDesktop className="mr-1" /> Member Area
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          onClick={() => {
                            setNavOpen(false);
                            setParentActive(true);
                          }}
                          to="/logout"
                          className="flex items-center w-40 bg-white  hover:bg-gray-400 hover:text-yellow-400 font-semibold py-2 px-4 block whitespace-no-wrap"
                          activeClassName="md:text-yellow-300">
                          <BiLogOutCircle className="mr-1" />
                          Logout
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              )}
            </ul>
            {!auth.check && (
              <div className="inline-flex rounded-md shadow-sm" role="group">
                <NavLink
                  to="/login"
                  type="button"
                  className="inline-flex items-center py-2 px-4 text-md font-medium text-gray-900 bg-yellow-400 border-none rounded-l-lg border  hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                  <BiLogIn className="mr-1" />
                  Login
                </NavLink>
                <NavLink
                  to="/daftar"
                  type="button"
                  className="inline-flex items-center py-2 px-4 text-md font-medium text-gray-900 bg-white border-none rounded-r-md border  hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                  <BiEdit className="mr-1" />
                  Register
                </NavLink>
              </div>
            )}
          </div>
        </div>
      </nav>

      <div>{children}</div>

      {children && <Footer />}
    </div>
  );
}

export default Navbar;
